"use client";

import Link from "next/link";
import React from "react";
import { Logo } from "./Logo";
import { useLocale } from "next-intl";
import { COMPANY } from "@/constants/company";

export const Footer = () => {
  const locale = useLocale();

  const links = [
    { name: locale === "de" ? "Preise" : "Pricing", href: `/${locale}/pricing` },
    { name: locale === "de" ? "Hilfe" : "Help", href: `/${locale}/help` },
    { name: locale === "de" ? "Kontakt" : "Contact", href: `/${locale}/contact` },
  ];
  const legal = [
    {
      name: locale === "de" ? "Datenschutzerklärung" : "Privacy Policy",
      href: `/${locale}/privacy-policy`,
    },
    {
      name: locale === "de" ? "Nutzungsbedingungen" : "Terms of Service",
      href: `/${locale}/terms`,
    },
    {
      name: locale === "de" ? "Rückerstattungsrichtlinie" : "Refund Policy",
      href: `/${locale}/refund-policy`,
    },
  ];
  const company = [
    { name: locale === "de" ? "Impressum" : "Imprint", href: `/${locale}/imprint` },
    {
      name: locale === "de" ? "Auftragsverarbeitung (AVV)" : "Data Processing (DPA)",
      href: `/${locale}/dpa`,
    },
    {
      name: locale === "de" ? "Unterauftragsverarbeiter" : "Subprocessors",
      href: `/${locale}/subprocessors`,
    },
    // Scalar-rendered OpenAPI reference, locale-free.
    { name: locale === "de" ? "API-Dokumentation" : "API Docs", href: "/docs/api" },
  ];

  return (
    <div className="relative">
      <div className="border-t border-neutral-100 dark:border-neutral-800 px-8 pt-20 pb-16 relative bg-white dark:bg-black">
        <div className="max-w-7xl mx-auto text-sm text-neutral-500 dark:text-neutral-400 flex sm:flex-row flex-col justify-between items-start">
          <div>
            <div className="mr-4 md:flex mb-4">
              <Logo />
            </div>
            <div>
              Copyright &copy; {new Date().getFullYear()} {COMPANY.brand} · {COMPANY.legalName}
            </div>
            <div className="mt-2">
              {locale === "de" ? "Alle Rechte vorbehalten" : "All rights reserved"}
            </div>
          </div>
          <div className="grid grid-cols-3 gap-x-4 gap-y-10 sm:gap-10 items-start mt-10 md:mt-0">
            <div className="flex justify-center space-y-4 flex-col mt-4">
              {links.map((link) => (
                <Link
                  key={link.name}
                  className="transition-colors hover:text-black text-muted dark:text-muted-dark dark:hover:text-neutral-400 text-xs sm:text-sm hyphens-auto break-words"
                  href={link.href}
                >
                  {link.name}
                </Link>
              ))}
            </div>
            <div className="flex justify-center space-y-4 flex-col mt-4">
              {legal.map((link) => (
                <Link
                  key={link.name}
                  className="transition-colors hover:text-black text-muted dark:text-muted-dark dark:hover:text-neutral-400 text-xs sm:text-sm hyphens-auto break-words"
                  href={link.href}
                >
                  {link.name}
                </Link>
              ))}
            </div>
            <div className="flex justify-center space-y-4 flex-col mt-4">
              {company.map((link) => (
                <Link
                  key={link.name}
                  className="transition-colors hover:text-black text-muted dark:text-muted-dark dark:hover:text-neutral-400 text-xs sm:text-sm hyphens-auto break-words"
                  href={link.href}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
